<template>
  <aside class="tw-hidden lg:tw-block">
    <div class="tw-mb-4 tw-flex tw-items-center tw-justify-between">
      <h4 class="tw-m-0 tw-text-lg tw-font-semibold tw-text-gray-900">
        Categorieën
      </h4>

      <c-button-icon
        v-if="isWebmaster"
        :icon="toClassicIcon(settingsIcon)"
        text-color="dark"
        flat
      >
        <c-menu auto-close>
          <q-list style="min-width: 200px">
            <q-item
              v-for="(item, index) in menuItems"
              :key="index"
              clickable
              @click="item.onClick"
            >
              <div class="tw-flex tw-items-center tw-gap-4">
                <q-icon size="12px" :name="toClassicIcon(item.icon)" />
                <div>{{ item.label }}</div>
              </div>
            </q-item>
          </q-list>
        </c-menu>
      </c-button-icon>
    </div>

    <div class="tw-flex tw-flex-col tw-gap-1">
      <c-banner v-if="!items.length" type="warning"
        >Er zijn geen categorieën gevonden</c-banner
      >

      <div
        v-for="category in items"
        :key="category.key"
        class="tw-flex tw-items-start tw-gap-1"
      >
        <menu-link
          :item="category"
          is-child
          class="tw-min-w-0 tw-flex-1 !tw-text-gray-900"
        />

        <c-button-icon
          v-if="isWebmaster"
          flat
          text-color="dark"
          :icon="toClassicIcon(verticalMenuIcon)"
          class="tw-h-10 tw-shrink-0"
        >
          <c-menu auto-close>
            <q-list style="min-width: 180px">
              <q-item clickable @click="openEditDialog(category.key)">
                <div class="tw-flex tw-items-center tw-gap-3">
                  <q-icon size="12px" :name="toClassicIcon(editIcon)" />
                  <div>Bewerken</div>
                </div>
              </q-item>
              <q-item clickable @click="openDeleteDialog(category.key)">
                <div class="tw-flex tw-items-center tw-gap-3 tw-text-negative">
                  <q-icon size="12px" :name="toClassicIcon(deleteIcon)" />
                  <div>Verwijderen</div>
                </div>
              </q-item>
            </q-list>
          </c-menu>
        </c-button-icon>
      </div>
    </div>
  </aside>
</template>

<script setup lang="ts">
import {
  deleteIcon,
  editIcon,
  settingsIcon,
  toClassicIcon,
  verticalMenuIcon,
} from "common/defaultIcons";
import MenuLink from "components/layout/MenuLink.vue";
import { useKnowledgeBaseCategoryActions } from "composables/knowledge-base/useKnowledgeBaseCategoryActions";
import { checkRole } from "composables/useHelpers";
import { computed } from "vue";

interface CategoryMenuItem {
  key: string;
  meta?: Record<string, unknown>;
  children?: unknown[];
  [extra: string]: unknown;
}

defineProps<{
  items: CategoryMenuItem[];
}>();

const isWebmaster = computed(() => checkRole("webmaster") === true);

const { menuItems, openEditDialog, openDeleteDialog } =
  useKnowledgeBaseCategoryActions();
</script>

<style scoped lang="scss">
// Articles nested under a sub-category sit inside a second-level submenu.
// Drop the extra left border line and its padding there so only the top-level
// category keeps its guide line and indentation.
:deep(.menu-item__submenu .menu-item__submenu) {
  @apply tw-border-l-0 tw-pl-0;
}
</style>
